import {Button as AntdButton, Button, Col, Divider, Row, theme} from 'antd'
import React from 'react'
import './weatherWidget.less'
import {ProjectWeather} from '../../entities/weather'
import plantsImageURL from 'url:../../../public/assets/images/plants.jpg'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'

export type WeatherWidgetProps = {
  weather?: ProjectWeather
  projectId: number
}

export function WeatherWidget(props: WeatherWidgetProps) {
  const navigate = useNavigate()
  const intl = useIntl()
  return (
    <div className="back">
      <div
        className="background-image"
        style={{
          backgroundImage: `url(${props?.weather ? props.weather.backImage : plantsImageURL})`,
        }}
      >
        <div className="background-image__gradient-overlay" />
      </div>
      {props.weather && (
        <>
          <Row className="current">
            <Col className="current__place-date">
              <div className="current__place">
                {props.weather.locationName.split(',').map((s, index) => (
                  <span key={index}>{s}</span>
                ))}
                <span>{props.weather.date}</span>
              </div>
            </Col>
            <Col className="current__weather">
              <div className="current__weather__temp">{props.weather.currentTempreture}°</div>
              <div className="current__weather__icon">{props.weather.icon}</div>
              <div className="current__weather__desc">{props.weather.description}</div>
            </Col>
          </Row>
          <Row className="week">
            {props.weather.nextDaysWeather.map((weather, index) => (
              <div className="week__day" key={index}>
                <div>{weather.dayOfWeek}</div>
                <div className="week__day__icon">{weather.icon}</div>
                <div>{weather.dayTemp}°</div>
                <div>{weather.nightTemp}°</div>
              </div>
            ))}
          </Row>
        </>
      )}
      {!props.weather && (
        <div className="without-weather">
          <Button
            ghost
            onClick={() => {
              navigate(`/projects/${props.projectId}/edit`)
            }}
          >
            {intl.formatMessage({id: 'toDisplayWeather'})}
          </Button>
        </div>
      )}
    </div>
  )
}
